import { StyleSheet, Text, View } from '@react-pdf/renderer';

import { TEXT_CONTENT } from '../../../utils/constants';
import { TableProps } from './Table.types';
import TableHeader from './TableHeader';
import TableRow from './TableRow';

// Create styles
const styles = StyleSheet.create({
  caption: {
    fontSize: 12,
    fontWeight: 700,
    paddingVertical: 10,
    paddingHorizontal: 5,
    borderWidth: 1,
    borderColor: '#bfbfbf',
  },
  section: {
    flexGrow: 1,
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    // borderWidth: 1,
    // borderColor: '#bfbfbf',
  },
  headerWrapper: {
    borderWidth: 1,
    borderColor: '#bfbfbf',
    borderBottomWidth: 0,
  },
});

const Table = ({
  rows = [],
  title = 'Table Example',
  columns = [],
  colGroupModel = [],
}: TableProps) => {
  const [firstRow, ...restRow] = rows;
  return (
    // <View style={styles.section}>
    <View style={styles.table}>
      <View wrap={false}>
        {/***Table Caption */}
        {title && <Text style={styles.caption}>{title}</Text>}
        {/* Table Header */}
        <TableHeader columns={columns} colGroupModel={colGroupModel} />
        {/* Table Rows */}
        {firstRow && (
          <TableRow
            key={`row-${firstRow.id}-0`}
            columns={columns}
            row={firstRow}
            allData={rows}
          />
        )}
      </View>
      <View>
        {Array.isArray(rows) && rows.length > 0 ? (
          restRow.map((row, rowIndex) => (
            <TableRow
              key={`row-${row.id}-${rowIndex + 1}`}
              columns={columns}
              row={row}
              allData={rows}
            />
          ))
        ) : (
          <Text
            style={{
              fontSize: 8,
              paddingHorizontal: 4,
              paddingVertical: 4,
              textAlign: 'center',
              borderWidth: 1,
              borderTopWidth: 0,
              borderColor: '#bfbfbf',
            }}
          >
            {TEXT_CONTENT.NO_ROWS_FOUND}
          </Text>
        )}
      </View>
    </View>
  );
};
export default Table;
